import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import RootRouter from './routes';
import injectTapEventPlugin from 'react-tap-event-plugin';

// Polyfills
import ArrayFromPolyfill from './lib/ArrayFromPolyfill';

/*
@TODO: hey kid, front-end kid, you want to add some sass, huh? it'll be a big change, but create-react-app supports it now
@TODO: revisit sass support thread (https://github.com/facebookincubator/create-react-app/issues/78)
*/
// Global css
import './index.css';

// Avoid `console` errors in browsers that lack a console.
(function() {
  let method;
  const noop = function () {};
  const methods = [
    'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
    'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
    'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
    'timeStamp', 'trace', 'warn'
  ];
  let length = methods.length;
  const console = (window.console = window.console || {});

  while (length--) {
    method = methods[length];

    // Only stub undefined methods.
    if (!console[method]) {
      console[method] = noop;
    }
  }
}());

// https://myupdox.atlassian.net/browse/POR-618
ArrayFromPolyfill();

/*eslint-disable */
if (process.env.NODE_ENV !== 'production') {
  if (console) {
    console.log(`
          WELCOME TO REACT PATIENT PORTAL
           == ${process.env.NODE_ENV} environment ==
     %c ________________________________________
               ,,,         ,,,
              ;"   ^;     ;'   ",
             ;    s$$$$$$$s     ;
             ',  ss$$$$$$$$$$s ,'
              ;s$$$$$$$$$$$$$$$
              $$$$$$$$$$$$$$$$$$
             $$$$$P""Y$$$Y""W$$$$$
             $$$$$ (p"$$$"q) $$$$$
              $$$$  .$$$$$.  $$$$
               $$PANDA$$$$$$$$$$
                 "$YE$"*"$$$$"
                    "$b.$$"
     by
     TrashPandas`, "font-family:monospace");
  }
}
/*eslint-disable */

const store = configureStore();

const App = () => (
  <MuiThemeProvider>
    <RootRouter />
  </MuiThemeProvider>
);


const globalAppEl = document.getElementById('app');

// Add css class to html to denote safari because Safari can be a little bitch sometimes
if (/Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor)) {
  document.getElementsByTagName('html')[0].className += ' safari';
}

// Needed for onTouchTap - Material UI dependency
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

if (globalAppEl) {
  render(
    <Provider store={store}>
      <App />
    </Provider>,
    globalAppEl,
  );
}

// @TODO add new registerServiceWorker() script that newer versions of create-react-app install with



// WEBPACK FOOTER //
// ./src/index.js